import type { TextareaHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import styles from './Input.module.css';

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ error, className, rows = 4, disabled, ...rest }, ref) => {
    const classes = [
      styles.textarea,
      error ? styles.error : '',
      className ?? '',
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <textarea
        ref={ref}
        className={classes}
        rows={rows}
        disabled={disabled}
        aria-invalid={error || undefined}
        {...rest}
      />
    );
  }
);

TextArea.displayName = 'TextArea';

export default TextArea;
